import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Collection from "@/components/Collection";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import BookingForm from "@/components/BookingForm";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";

const GRAIN =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='120' height='120' filter='url(%23n)' opacity='0.4'/%3E%3C/svg%3E\")";

export default function App() {
  const [prefill, setPrefill] = useState({ bookingType: null, service: null, token: 0 });

  const applyPrefill = (patch) =>
    setPrefill((prev) => ({ ...prev, ...patch, token: prev.token + 1 }));

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional one-time Lenis init on mount
  }, []);

  return (
    <div className="min-h-screen bg-alabaster text-ink font-sans antialiased overflow-x-clip">
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 z-[60] opacity-[0.05] mix-blend-multiply"
        style={{ backgroundImage: GRAIN }}
      />
      <Navbar />
      <main>
        <Hero />
        <Collection onSelectService={(service) => applyPrefill({ service })} />
        <Manifesto />
        <Services onSelectType={(bookingType) => applyPrefill({ bookingType })} />
        <BookingForm prefill={prefill} />
        <Faq />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}
